/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/avatar/Avatar.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { Avatar as AntdAvatar } from 'antd';
import { ConfigContext } from '../config-provider';
import SizeContext from './SizeContext';
import Group from './Group';
const InternalAvatar = React.forwardRef((props, ref) => {
    const groupSize = React.useContext(SizeContext);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className, size, ...otherProps } = props;
    const customSize = size === 'default' ? groupSize : size;
    const prefixCls = getPrefixCls('avatar', customizePrefixCls);
    const newClassName = classNames({
        [`${prefixCls}-xl`]: customSize === 'xl'
    }, className);
    const customProps = otherProps;
    if (customSize !== 'xl') {
        return (React.createElement(AntdAvatar, { prefixCls: prefixCls, className: newClassName, ...customProps, size: customSize, ref: ref }));
    }
    return React.createElement(AntdAvatar, { prefixCls: prefixCls, className: newClassName, ...customProps, ref: ref });
});
const Avatar = InternalAvatar;
Avatar.Group = Group;
Avatar.displayName = AntdAvatar.displayName;
Avatar.defaultProps = AntdAvatar.defaultProps;
// export default withConfigProvider(Avatar);
export default Avatar;
